import React from 'react'
import image from '@loyal_images/products/product_placeholder.png'
import ImageGallery from 'react-image-gallery'
// import PropTypes from 'prop-types'

import 'react-image-gallery/styles/css/image-gallery.css'

const ProductImagePlaceholder = isVoucher => (
  <div className={`product-image ${isVoucher ? 'voucher' : ''}`}>
    <ImageGallery
      showPlayButton={false}
      showFullscreenButton={false}
      useBrowserFullscreen={false}
      showNav={false}
      showThumbnails={!isVoucher}
      items={[
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        },
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        },
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        },
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        },
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        },
        {
          original: image,
          originalClass: '',
          thumbnail: image,
          thumbnailClass: 'radius mt-2'
        }
      ]}
    />
  </div>
)

// ProductImagePlaceholder.propTypes = {
//   isVoucher: PropTypes.bool.isRequired
// }

export default ProductImagePlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductImage/ProductImagePlaceholder.js